import React, { Component } from "react";
import { DatePicker } from "../../../component";
import { DatePickerStyled } from "../../../component/DatePickerMilestone";
import { Form, Button } from "react-bootstrap";
import { get } from "lodash";
import TextAreaField from "../../../component/InputFieldLayout/textAreaField";

class CompletedBucket extends Component {
  onAddingDisable = (e, bucketId) => {
    this.props.onChange(e.target.value, "bucketDelayReason", bucketId);
  };
  ZIndex = value => {
    // this.props.ZIndex(value)
  };
  render() {
    const {
      bucketId,
      onChange,
      bucketMilestoneCOS,
      onBlur,
      isMilestoneTableValidated
    } = this.props;

    let _selectedBucketData =
      bucketMilestoneCOS &&
      bucketMilestoneCOS.length &&
      bucketMilestoneCOS.find(bucket => bucket.bucketId === bucketId);

    let fieldForCostAndArea =
      _selectedBucketData &&
      _selectedBucketData.bucketType === "COST_AND_DATES_AND_AREA";

    let fieldsForCompletedCost =
      (_selectedBucketData &&
        _selectedBucketData.bucketType === "COST_AND_DATES") ||
      fieldForCostAndArea;

    let showErrorForPhases =
      _selectedBucketData &&
      !_selectedBucketData.disabled &&
      _selectedBucketData.completed &&
      isMilestoneTableValidated === false;

    return (
      <React.Fragment>
        <div className="completed-section-wrapper">
          <div className={"date-section-one"}>
            <div
              className="heading-text"
              data-test="label-scheduled-date-of-start"
            >
              Scheduled date of start
            </div>
            <div className="date-section-left">
              <Form.Group className="field-datepicker left-date-field">
                <Form.Label data-test="label-original">
                  Original<span className="required">*</span>
                </Form.Label>
                <div>
                  <div className="form-field">
                    <DatePickerStyled
                      // isClearable={}
                      value={
                        _selectedBucketData &&
                        _selectedBucketData.originalScheduledStartDate
                      }
                      selected={
                        _selectedBucketData &&
                        _selectedBucketData.originalScheduledStartDate
                      }
                      onChange={value => {
                        console.log("value69", value);
                        onChange(value, "originalScheduledStartDate", bucketId);
                      }}
                      className={
                        _selectedBucketData &&
                        !_selectedBucketData.disabled &&
                        _selectedBucketData.completed &&
                        isMilestoneTableValidated === false &&
                        !_selectedBucketData.originalScheduledStartDate
                          ? " error-milestone"
                          : ""
                      }
                      isCompleted={true}
                      setZIndex={this.ZIndex}
                    />
                  </div>
                </div>
              </Form.Group>
              <Form.Group className="field-datepicker right-date-field">
                <Form.Label data-test="label-revised-or-actual">
                  Revised/Actual<span className="required">*</span>
                </Form.Label>
                <div>
                  <div className="form-field">
                    <DatePickerStyled
                      // isClearable={}
                      value={
                        _selectedBucketData &&
                        _selectedBucketData.revisedScheduledStartDate
                      }
                      selected={
                        _selectedBucketData &&
                        _selectedBucketData.revisedScheduledStartDate
                      }
                      onChange={value => {
                        onChange(value, "revisedScheduledStartDate", bucketId);
                      }}
                      className={
                        _selectedBucketData &&
                        !_selectedBucketData.disabled &&
                        _selectedBucketData.completed &&
                        isMilestoneTableValidated === false &&
                        !_selectedBucketData.revisedScheduledStartDate
                          ? " error-milestone"
                          : ""
                      }
                      isCompleted={true}
                      setZIndex={this.ZIndex}
                    />
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="date-section">
            <div
              className="heading-text"
              data-test="label-scheduled-date-of-finish"
            >
              Scheduled date of finish
            </div>
            <div className="date-section-left">
              <Form.Group className="field-datepicker left-date-field">
                <Form.Label data-test="label-finish-original-date">
                  Original<span className="required">*</span>
                </Form.Label>
                <div>
                  <div className="form-field">
                    <DatePickerStyled
                      // isClearable={}
                      value={
                        _selectedBucketData &&
                        _selectedBucketData.originalScheduledFinishDate
                      }
                      selected={
                        _selectedBucketData &&
                        _selectedBucketData.originalScheduledFinishDate
                      }
                      onChange={value => {
                        onChange(
                          value,
                          "originalScheduledFinishDate",
                          bucketId
                        );
                      }}
                      className={
                        _selectedBucketData &&
                        !_selectedBucketData.disabled &&
                        _selectedBucketData.completed &&
                        isMilestoneTableValidated === false &&
                        !_selectedBucketData.originalScheduledFinishDate
                          ? " error-milestone"
                          : ""
                      }
                      isCompleted={true}
                      originalScheduledStartDate={null}
                      setZIndex={this.ZIndex}
                    />
                  </div>
                </div>
              </Form.Group>
              <Form.Group className="field-datepicker right-date-field">
                <Form.Label data-test="label-finish-revised-or-actual-date">
                  Revised/Actual<span className="required">*</span>
                </Form.Label>
                <div>
                  <div className="form-field">
                    <DatePickerStyled
                      // isClearable={}
                      value={
                        _selectedBucketData &&
                        _selectedBucketData.revisedScheduledFinishDate
                      }
                      selected={
                        _selectedBucketData &&
                        _selectedBucketData.revisedScheduledFinishDate
                      }
                      onChange={value => {
                        onChange(value, "revisedScheduledFinishDate", bucketId);
                      }}
                      className={
                        _selectedBucketData &&
                        !_selectedBucketData.disabled &&
                        _selectedBucketData.completed &&
                        isMilestoneTableValidated === false &&
                        !_selectedBucketData.revisedScheduledFinishDate
                          ? " error-milestone"
                          : ""
                      }
                      isCompleted={true}
                      revisedScheduledStartDate={null}
                      setZIndex={this.ZIndex}
                    />
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div
          className={`${
            fieldsForCompletedCost
              ? "completed-section-wrapper cost-section-wrapper"
              : ""
          }`}
        >
          {fieldsForCompletedCost ? (
            <div
              className={
                _selectedBucketData &&
                _selectedBucketData.bucketName !== "Construction"
                  ? "date-section-one"
                  : " date-section-one construction-wrapper"
              }
            >
              <div
                className="heading-text"
                data-test="label-scheduled-date-of-finish"
              >
                {_selectedBucketData &&
                _selectedBucketData.bucketName === "Land Acquisition"
                  ? " Land Acquisition Cost (in crores)"
                  : "Construction Cost (in crores)"}
              </div>
              <div className="date-section-left">
                <Form.Group className="field-cost field-datepicker left-date-field">
                  <Form.Label>
                    Original<span className="required">*</span>
                  </Form.Label>
                  <div>
                    <div className="form-field">
                      <span className="symbol-field-left">
                        <Form.Control
                          type="text"
                          value={get(_selectedBucketData, "originalCost", "")}
                          onChange={e =>
                            onChange(e.target.value, "originalCost", bucketId)
                          }
                          className={
                            showErrorForPhases &&
                            !_selectedBucketData.originalCost
                              ? " error-milestone"
                              : ""
                          }
                        />
                        <span>Cr.</span>
                      </span>
                    </div>
                  </div>
                </Form.Group>
                <Form.Group className="field-cost field-datepicker right-date-field">
                  <Form.Label>
                    Revised/Actual<span className="required">*</span>
                  </Form.Label>
                  <div>
                    <div className="form-field">
                      <span className="symbol-field-left">
                        <Form.Control
                          type="text"
                          value={get(_selectedBucketData, "revisedCost", "")}
                          onChange={e =>
                            onChange(e.target.value, "revisedCost", bucketId)
                          }
                          className={
                            showErrorForPhases &&
                            !_selectedBucketData.revisedCost
                              ? " error-milestone"
                              : ""
                          }
                        />
                        <span>Cr.</span>
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>
          ) : null}
          {fieldForCostAndArea ? (
            <div className="date-section">
              <div
                className="heading-text"
                data-test="label-scheduled-date-of-finish"
              >
                Land Acquisition Area (in hectares)
              </div>
              <div className="date-section-left">
                <Form.Group className="field-cost field-datepicker left-date-field">
                  <Form.Label>
                    Original<span className="required">*</span>
                  </Form.Label>
                  <div>
                    <div className="form-field">
                      <span className="symbol-field-left symbol-area">
                        <Form.Control
                          type="text"
                          value={get(_selectedBucketData, "originalArea", "")}
                          onChange={e =>
                            onChange(e.target.value, "originalArea", bucketId)
                          }
                          className={
                            showErrorForPhases &&
                            !_selectedBucketData.originalArea
                              ? " error-milestone"
                              : ""
                          }
                        />
                        <span>Ha.</span>
                      </span>
                    </div>
                  </div>
                </Form.Group>
                <Form.Group className="field-cost field-datepicker right-date-field">
                  <Form.Label>
                    Revised/Actual<span className="required">*</span>
                  </Form.Label>
                  <div>
                    <div className="form-field">
                      <span className="symbol-field-left symbol-area">
                        <Form.Control
                          type="text"
                          value={get(_selectedBucketData, "revisedArea", "")}
                          onChange={e =>
                            onChange(e.target.value, "revisedArea", bucketId)
                          }
                          className={
                            showErrorForPhases &&
                            !_selectedBucketData.revisedArea
                              ? " error-milestone"
                              : ""
                          }
                        />
                        <span>Ha.</span>
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>
          ) : null}
        </div>
        <div className="disable-bucket-reason">
          <TextAreaField
            label={"Reason For Delay"}
            placeholder={"Add reason for delay"}
            formData={get(_selectedBucketData, "bucketDelayReason", "")}
            bucketId={bucketId}
            onChange={this.onAddingDisable}
            className="delay-reason"
          />
        </div>
      </React.Fragment>
    );
  }
}

export default CompletedBucket;
